import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dt__filterSorting" }
const _hoisted_2 = { class: "dt__filterSorting-button" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "dt-sortingIcon" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "dt__filterSorting-button_isDesktop"
}
const _hoisted_5 = { class: "dt__filterSorting-content" }
const _hoisted_6 = { class: "dt__filterSorting-content-header" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Сортировка", -1 /* HOISTED */)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.000244141",
  y: "1.41406",
  width: "2",
  height: "16",
  rx: "1",
  transform: "rotate(-45 0.000244141 1.41406)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rect", {
  x: "11.3137",
  width: "2",
  height: "16",
  rx: "1",
  transform: "rotate(45 11.3137 0)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "dt__filterSorting-content-wrapper" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "dt-checkIcon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Popper, {
      offsetSkid: "0",
      placement: "bottom-end"
    }, {
      content: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(), _createElementBlock("svg", {
              onClick: close,
              width: "13",
              height: "13",
              viewBox: "0 0 13 13",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_11, 8 /* PROPS */, _hoisted_8))
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.list, (sort) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sort.id,
                onClick: ($event: any) => {$options.onChecked(sort); close()},
                class: _normalizeClass(["dt__filterSorting-content-wrapper-elem", sort.equals(this.modelValue) ? 'active' : ''])
              }, [
                _createTextVNode(_toDisplayString(sort.title) + " ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("div", _hoisted_14, null, 512 /* NEED_PATCH */), [
                  [_vShow, sort.equals(this.modelValue)]
                ])
              ], 10 /* CLASS, PROPS */, _hoisted_13))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (!this.desktopHidden)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(this.modelValue.title), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}